import clsx from 'clsx';
import React, { type PropsWithChildren, type ReactElement } from 'react';

export type Props = {
  classNames?: string[] | string;
  detail: ReactElement;
};

export const TableHoverDetailRow = ({
  detail,
  children,
  classNames,
}: PropsWithChildren<Props>): JSX.Element => (
  <div className="flex flex-row space-x-[1ch] min-w-f0">
    <div className={clsx('flex min-w-f0 flex-shrink', classNames)}>
      {children}
    </div>
    <div className="flex-shrink-0 flex justify-center items-center">
      {detail}
    </div>
  </div>
);
